import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isMobileMode } = {}) => ({
  listButton: { marginRight: 16 },
  gridButton: { marginRight: isMobileMode ? 0 : 28 },
}));
